<template>
  <page-wrapper :title="title">
    <div class="wrapper">
      <financial-institution-editor
        v-model="form"
      ></financial-institution-editor>
      <div class="d-flex justify-content-between mt-4">
        <sc-button variant="danger" @click="handleClickRemove">ลบ</sc-button>
        <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper"
import ScButton from "@/lib/components/ScButton"
import { baanRueJaiClient } from "@/dependencies"
import FinancialInstitutionEditor from "../components/FinancialInstitutionEditor"

export default {
  components: {
    PageWrapper,
    ScButton,
    FinancialInstitutionEditor,
  },
  data() {
    const title = "รายละเอียดสถาบันการเงิน"
    const form = {
      name: "",
      code: "",
    }
    return { title, form }
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {
      this.setupData()
    },
    setupData() {
      this.setupForm()
    },
    async setupForm() {
      const data = await this.fetchData()
      const { name, code } = data

      this.form = {
        name,
        code,
      }
    },
    async fetchData() {
      const { id } = this.$route.params
      const response = await baanRueJaiClient.admin.financialInstitution.get(id)

      return response.data.result
    },
    async handleClickSave() {
      try {
        await this.updateFinancialInstitution()
        this.$router.push({ name: "FinancialInstitutionListPage" })
      } catch (err) {
        this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง")
        // eslint-disable-next-line no-console
        console.error(err)
      }
    },
    async updateFinancialInstitution() {
      const { id } = this.$route.params
      const { name, code } = this.form
      const params = { name, code }

      const response = await baanRueJaiClient.admin.financialInstitution.put(
        id,
        params,
      )

      return response
    },
    async handleClickRemove() {
      // eslint-disable-next-line no-alert
      if (!window.confirm("ยืนยันการลบสถาบันการเงิน")) {
        return
      }

      try {
        await this.removeFinancialInstitution()
        this.$router.push({ name: "FinancialInstitutionListPage" })
      } catch (err) {
        this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง")
        // eslint-disable-next-line no-console
        console.error(err)
      }
    },
    async removeFinancialInstitution() {
      const { id } = this.$route.params

      await baanRueJaiClient.admin.financialInstitution.delete(id)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
  padding-left: $space;
  padding-right: $space;
}

.editor {
  margin-bottom: $space;
}
</style>
